const getNormalizedString = string => string
    .split('ё')
    .join('е')
    .split('Ё')
    .join('Е')
    .toLowerCase();

export default getNormalizedString;
